module.exports = __webpack_public_path__ + "img/nav_logo.61954a23.svg";